import { useDialogControl } from '@hooks/other/useDialogControl';
import { useGetMintRows } from '@hooks/queries/registry/mint/useGetMintRows';
import React from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { GridRowParams } from '@mui/x-data-grid';
import { ChoiceDialog } from '../../../components/ChoiceDialog';
import { DataTable } from '../../../components/Table/DataTable';
import { Details } from '../../../components/Table/Details';
import { createColumns } from '../../../components/Table/createColumns';
import { RowNew } from '../../../components/Table/types';
import { useCreateChoices } from '../../../components/Table/useCreateChoices';
import { PageWrapper } from '../../PageWrapper';
import { RequestMintDialog } from './RequestMintDialog';

export const MintsPage: React.FC = () => {
  const [selectedRow, setSelectedRow] = React.useState<RowNew | undefined>();
  const { dialogName, setDialogName, onCloseDialog } = useDialogControl();
  const onRowClick = (r: GridRowParams<RowNew>) => {
    setSelectedRow(r.row);
  };
  const { rows, isLoading } = useGetMintRows();
  const onClose = () => {
    setSelectedRow(undefined);
  };
  const buttons = [
    {
      name: 'Request mint',
      onClick: () => setDialogName('mint'),
    },
  ];
  const columns = createColumns();
  const actions = useCreateChoices(onClose, selectedRow);
  const pageName = (
    <Stack direction="row" sx={{ display: 'flex', flex: 1 }}>
      <Typography variant="h4" color="primary">
        Mints
      </Typography>

      {isLoading && <CircularProgress sx={{ ml: 2, mt: 0.5 }} size={20} />}
    </Stack>
  );
  return (
    <PageWrapper buttons={buttons} pageName={pageName}>
      <ChoiceDialog title="Mint details" open={!!selectedRow} onClose={onClose} actions={actions}>
        {selectedRow && <Details row={selectedRow} />}
      </ChoiceDialog>
      <RequestMintDialog open={dialogName === 'mint'} onClose={onCloseDialog} />
      <DataTable
        rows={rows}
        rowKey={(a) => a.contractId}
        columns={columns}
        onRowClick={onRowClick}
      />
    </PageWrapper>
  );
};
